import React from "react";
import { Button } from "react-bootstrap";

const fallbackImg =
  "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png";

export default function UserHeader({ userProfileImage, userData, fullName, onBack }) {
  console.log(userProfileImage);
  return (
    <div className="user-details-card">
      <div className="user-details-header d-flex justify-content-between align-items-center">
        <div className="user-header">User Details</div>
        <Button variant="light" onClick={()=>{
          window.history.back();
        }} className="previous-btn border rounded-pill px-4 py-2 fw-medium">
          Previous
        </Button>
      </div>
      <div className="user-avatar-wrapper text-center mb-2">
        <img
          src={userProfileImage || fallbackImg}
          onError={(e) => (e.currentTarget.src = fallbackImg)}
          alt="Profile"
          className="user-avatar"
        />
        <div className="atom-badge mt-3">
          Atom ID: <span>#{userData?.atom_id || "—"}</span>
        </div>
      </div>
    </div>
  );
}
